export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-5-sm-eb46078923570540fb608118a2bcd8bb.png";